document.querySelectorAll('.ToggleBase').forEach(ToggleBaseInit)

function ToggleBaseInit(el) {
    checkInit(el, () => {
        const classActive = 'ToggleBase__item--active';
        const inputs = Array.from(el.querySelectorAll('input'));
        const bg = el.querySelector('.ToggleBase__bg');
        waitRenderEl(el, () => {
            const index = inputs.findIndex((input) => input.checked);
            if(~index) {
                setPosition(index);
            }
            else {
                inputs[0].checked = true;
                setPosition(0);
            }
        });

        inputs.forEach((input, index) => {
            input.addEventListener('change', (e) => {
                if(input.checked) {
                    setPosition(index);
                }
            })
        });

        function setPosition(index) {
            const box = inputs[index].parentElement;
            bg.style.width = `${box.offsetWidth}px`;
            bg.style.left = `${box.offsetLeft}px`;
            setActive(index);
        }
        function setActive(index) {
            inputs.forEach((el, i) => {
                el.parentElement.classList.toggle(classActive, index === i)
            });
        }
    })
}


function waitRenderEl(el, cb) {
    try {
        const resizeObserver = new ResizeObserver(function() {
            if (el.offsetWidth) {
                resizeObserver.disconnect();
                cb();
            }
        });
        resizeObserver.observe(el);
    }
    catch (e) {
        setTimeout(cb, 1000);
    }
}
